import * as React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from "@reach/accordion";
import { useMaintenance } from "@nju/data-access-portal-technical";
import { Icon } from "@nju/icons";
import { Text } from "@nju/ui";

export function MaintenanceAlert() {
  const [longFeaturesExpanded, setLongFeaturesExpanded] = React.useState(false);
  const { messageSellersNWT } = useMaintenance();

  if (!messageSellersNWT?.title) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <div className="flex">
      <div className="px-1 pt-4 bg-ripeLemon from-tablet:px-2">
        <Icon
          className="only-mobile:hidden"
          height={24}
          name="info-circle"
          width={24}
        />
      </div>
      <div className="p-4 max-w-[1240px] from-tablet:px-12">
        <Text weight="bold">{messageSellersNWT.title}</Text>
        {messageSellersNWT.body && (
          <Accordion
            collapsible={true}
            onChange={() => {
              setLongFeaturesExpanded(!longFeaturesExpanded);
            }}
          >
            <AccordionItem>
              <AccordionPanel className="mt-4">
                {messageSellersNWT.body}
              </AccordionPanel>
              <AccordionButton className="mt-2 underline cursor-pointer border-none bg-transparent">
                <div>{longFeaturesExpanded ? "zwiń" : "rozwiń"}</div>
              </AccordionButton>
            </AccordionItem>
          </Accordion>
        )}
      </div>
    </div>
  );
}
